import { Component, OnInit, ChangeDetectorRef, ViewChild, HostListener } from "@angular/core";
import {
  Order,
  OrderSearchParams,
  RXForm,
} from "src/app/shared/models/order.model";
import { TabIdList } from "src/app/shared/models/tab.model";
import { BroshService } from "src/app/shared/services/brosh.service";
import { RxLockService } from "src/app/shared/services/rx-lock.service";
import { AuthService } from "src/app/shared/services/auth.service";
import { SharedService } from "src/app/shared/services/shared.service";
import { ChatService } from "src/app/shared/services/chat.service";
import {
  ChatContact,
  ChatMsg,
  ChatTask,
  NotificationTypeEnum,
} from "src/app/shared/models/chat.model";
import { ofType, Actions } from "@ngrx/effects";
import { map, take, takeUntil } from "rxjs/operators";
import { DataElement } from "src/app/shared/models/common";
import { OrderNotesComponent } from "./order-notes/order-notes.component";
import { Router, RouterModule } from "@angular/router";
import { RouteEnum } from "src/app/shared/models/routes.model";
import { Store } from "@ngrx/store";
import { Subject } from "rxjs";
import {
  CREATE_TASK_FOR_CHAT_MSG,
  MARK_INBOX_NEEDS_RELOAD,
  SELECT_CHAT_CONTACT,
  SELECT_CHAT_TASK,
  SELECT_RX_FORM,
} from "src/app/shared/ngrx/ngrx-actions";
import {
  currentChatContact,
  currentChatTask,
  currentOrder,
} from "src/app/shared/ngrx/ngrx-selectors";
import { CommonModule } from "@angular/common";
import { EditChatTaskComponent } from "./chat-tasks/edit-chat-task/edit-chat-task.component";
import { ModalPopupComponent } from "src/app/shared/components/ui/modal-popup.component";
import { OrderChatComponent } from "./order-chat/order-chat.component";
import { OrderHeaderComponent } from "./order-header/order-header.component";
import { LoaderComponent } from "src/app/shared/components/ui/loader/loader.component";

export class ChatTab {
  contact: ChatContact;
  tabTitle: string;
  tabId: string;
  constructor() {}
}

@Component({
  selector: "order-summary",
  templateUrl: "./order-summary.component.html",
  styleUrls: ["./order-summary.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    EditChatTaskComponent,
    ModalPopupComponent,
    OrderChatComponent,
    OrderHeaderComponent,
    RouterModule,
    LoaderComponent,
  ],
})
export class OrderSummaryComponent {
  @ViewChild("notesCmp") notesCmp: OrderNotesComponent;

  displayChatPopup: boolean;
  displayChatTaskPopup: boolean;
  routeEnum: RouteEnum = new RouteEnum();
  destroy$ = new Subject();
  currentChatContact$ = this.store.select(currentChatContact);
  selectedChatTask$ = this.store.select(currentChatTask);

  get currentOrder(): Order {
    return this.store.selectSignal(currentOrder)();
  }

  constructor(
    private readonly store: Store,
    private router: Router,
    private actions$: Actions,
    private broshService: BroshService,
    private rxLock: RxLockService,
    private authService: AuthService
  ) {}

  // Anything the user does inside the order keeps their RX lock active.
  @HostListener("click")
  @HostListener("keydown")
  onActivity(): void {
    this.rxLock.noteActivity();
  }

  ngOnDestroy(): void {
    this.destroy$.next(1);
    this.rxLock.stop();
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.actions$
      .pipe(
        ofType(SELECT_CHAT_TASK),
        takeUntil(this.destroy$),
        map(({}) => {
          this.displayChatPopup = false;
          this.displayChatTaskPopup = true;
        })
      )
      .subscribe();

    this.actions$
      .pipe(
        ofType(CREATE_TASK_FOR_CHAT_MSG),
        takeUntil(this.destroy$),
        map(({ msg }) => {
          this.createChatTask(msg);
        })
      )
      .subscribe();

    if (this.currentOrder.statusCode == "CLINIC_SIGNED") {
      this.openClinicSignedRx();
    }
  }

  // An intake case is taken on open and shows the form the take returned;
  // any other signed order opens its first digital RX as before. Only the lab
  // takes a case: anyone else sees the order, its files and chat, and no RX.
  // A refused take (the case moved on meanwhile) goes back to a reloaded inbox;
  // handleErrorNew has already shown why.
  openClinicSignedRx(): void {
    if (this.currentOrder.intake) {
      if (this.authService.currentUser.org != "LAB") return;
      this.broshService.takeIntakeCase(this.currentOrder.orderId).subscribe({
        next: (result) => this.openRx(result.formId),
        error: () => {
          this.store.dispatch(MARK_INBOX_NEEDS_RELOAD());
          this.router.navigate([this.routeEnum.URL_INBOX]);
        },
      });
      return;
    }

    let firstRx = this.currentOrder.files.find((f) => f.rxType == "DIGITAL");
    if (firstRx) {
      this.openRx(firstRx.formId);
    }
  }

  private openRx(formId: number): void {
    let form = new RXForm();
    form.formId = formId;
    this.store.dispatch(SELECT_RX_FORM({ form: form }));
    this.router.navigate([this.routeEnum.URL_ORDER_RX]);
  }

  createChatTask(msg: ChatMsg) {
    let newTask = new ChatTask();
    newTask.msgId = msg.msgId;
    newTask.msgTxt = msg.fileId ? "קובץ מצורף" : msg.msgText;
    newTask.msgFromUserDescr = msg.fromUserDescr;
    newTask.msgTimestamp = msg.timestamp;
    newTask.status = new DataElement("OPEN", "בטיפול");

    this.store.dispatch(
      SELECT_CHAT_TASK({
        task: newTask,
      })
    );

    this.displayChatPopup = false;
    this.displayChatTaskPopup = true;
  }

  onChatOpenClicked(contact: ChatContact) {
    this.store.dispatch(
      SELECT_CHAT_CONTACT({
        chatContact: contact,
      })
    );
    this.displayChatPopup = true;
  }
}
